import { StoredDismissedAlert } from './types';
import { getComparisonKey } from './serialization';
import { DateTime } from 'luxon';

/**
 * Groups dismissed alerts by their comparison key and returns a record of the latest dismissed date for each key.
 */
export const reduceToDismissDateAndIndexByKey = (
  alerts: StoredDismissedAlert[],
): Record<string, DateTime<true>> => {
  return alerts.reduce<Record<string, DateTime<true>>>((collection, alert) => {
    // Create the comparison key for the alert
    let key = getComparisonKey(alert);

    // Check if the key already exists in the collection
    let previous: DateTime<true> | undefined = collection[key];

    // If the key doesn't exist, add it to the collection with the dismissed date
    if (typeof previous === 'undefined') {
      return {
        ...collection,
        [key]: alert.dismissedAt,
      };
    }

    // If the key exists, compare the dismissed dates and keep the latest one
    let current = alert.dismissedAt;

    if (current > previous) {
      return {
        ...collection,
        [key]: alert.dismissedAt,
      };
    }

    // If the current date is not later, return the collection as is
    return collection;
  }, {});
};

// export const groupByComparisonKey = (
//   alerts: StoredDismissedAlert[],
// ): Record<string, StoredDismissedAlert> => {
//   return alerts.reduce<Record<string, StoredDismissedAlert>>(
//     (collection, alert) => {
//       let key = getComparisonKey(alert);
//
//       return {
//         ...collection,
//         [key]: alert,
//       };
//     },
//     {},
//   );
// };
